import React from 'react';
import {
  Avatar,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '../../../extended-oxygen-elements';
import {
  CloseIcon,
  PageDialog,
  PageDialogCancel,
  PageDialogErrors,
  PageDialogSubmit,
  WarningAmberOutlinedIcon,
} from '../../../element';

type Props = {
  isOpened: boolean;
  onClose: () => void;
  handleSubmit: () => void;
  details: string;
};

export const RemoveCustomBreakRuleDialog = ({
  isOpened,
  onClose,
  handleSubmit,
  details,
}: Props) => {
  return (
    <PageDialog open={isOpened} maxWidth="xs">
      <DialogTitle>
        <Avatar size="large" color="error" light aria-label={'delete'}>
          <WarningAmberOutlinedIcon />
        </Avatar>
      </DialogTitle>
      <DialogContent>
        <PageDialogErrors />
        <Typography variant="h5" gutterBottom>
          Delete Break Rule
        </Typography>
        <Typography variant={'caption'} paddingBottom={2}>
          {details}
        </Typography>
        <Typography paddingTop={2}>
          You're sure you want to delete this item?
        </Typography>
        <Typography>
          You will need to recreate the rule if this is done in error.
        </Typography>
      </DialogContent>
      <DialogActions>
        <PageDialogCancel
          variant="outlined"
          size="medium"
          onClick={onClose}
          fullWidth
        >
          Cancel
        </PageDialogCancel>
        <PageDialogSubmit fullWidth variant="contained" onClick={handleSubmit}>
          Delete
        </PageDialogSubmit>
      </DialogActions>
    </PageDialog>
  );
};
